import { EmployeeGroupingEnum } from '@/types/employeeGrouping';

import { RootState } from '../types';

export const selectSelectedEmployeeGroups = (state: RootState) => state.reducer.employeeGrouping.selectedGroups;

export const selectAreEmployeesGrouped = (state: RootState) =>
  state.reducer.employeeGrouping.selectedGroups[0] !== EmployeeGroupingEnum.NONE;
